module.exports = {
  STATE_ERROR: 'error',
  STATE_WAITING: 'waiting',
  STATE_PREPROCESSING: 'preprocessing',
  STATE_UPLOADING: 'uploading',
  STATE_POSTPROCESSING: 'postprocessing',
  STATE_COMPLETE: 'complete'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uppy/status-bar/lib/StatusBarStates.js
// module id = 475
// module chunks = 0